/**
 * Talala API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GetOffers401Response { 
    error_key?: GetOffers401Response.ErrorKeyEnum;
}
export namespace GetOffers401Response {
    export type ErrorKeyEnum = 'authorization.invalid';
    export const ErrorKeyEnum = {
        AuthorizationInvalid: 'authorization.invalid' as ErrorKeyEnum
    };
}


